export default __webpack_public_path__ + "static/media/incendiaryshot.a6aab75a.png";